<div class="cell auto grid-y cell-block-y blockContent" *ngIf="marketShares">
    <div class="cell shrink grid-x grid-margin-x align-middle align-center">
        <div class="cell shrink grid-y align-center align-spaced">
            <h3 class="cell shrink _primary"[i18nKey]="'studies.competitive.intelligence.product.market.shares.covers'"></h3>
            <kiwi-spacer [size]="16"></kiwi-spacer>
            <div class="cell shrink">
                <canvas height="400px"
                        baseChart
                        [data]="pieChartDataInCovers"
                        [options]="pieChartOptions"
                        [legend]="pieChartLegend"
                        [type]="pieChartType">
                </canvas>
            </div>
        </div>
        <div class="cell shrink grid-y align-center align-middle">
            <h3
                class="cell shrink _primary"[i18nKey]="'studies.competitive.intelligence.product.market.shares.turnover'"></h3>
            <kiwi-spacer [size]="16"></kiwi-spacer>
            <div class="cell shrink">
                <canvas
                    height="400px"
                    baseChart
                    [data]="pieChartDataInTurnover"
                    [options]="pieChartOptions"
                    [legend]="pieChartLegend"
                    [type]="pieChartType">
                </canvas>
            </div>
        </div>
    </div>

    <kiwi-spacer [size]="24"></kiwi-spacer>

    <div class="cell shrink" *ngIf="marketShares">
        <table class="_tableColor">
            <tbody>
            <tr class="_titlePartTable">
                <td [i18nKey]="'common.team'"></td>
                <td [i18nKey]="'studies.competitive.intelligence.trade.name'"></td>
                <td [i18nKey]="'common.area'"></td>
                <td [i18nKey]="'common.restaurant.type'"></td>
                <td class="_number"[i18nKey]="'studies.competitive.intelligence.product.market.shares.covers'"></td>
                <td class="_number"[i18nKey]="'studies.competitive.intelligence.product.market.shares.turnover'"></td>
            </tr>
            <tr *ngFor="let teamData of marketShares.marketSharesInCovers.teamsData; index as i">
                <td>{{teamData.teamNumber}}</td>
                <td>{{teamData.teamName}}</td>
                <td>{{'common.area.' + teamData.teamArea | translate}}</td>
                <td>{{'common.restaurant.type.' + teamData.teamRestaurantType | translate}}</td>
                <td class="_number">{{teamData.teamValue | number:'1.2'}} %</td>
                <td class="_number">{{marketShares.marketSharesInTurnover.teamsData[i].teamValue | number:'1.2'}} %</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
